module.exports = __webpack_public_path__ + "static/images/7ba2b02e0da8851f76026e4732ba2d37.png";